/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import { SVGProps } from 'react';

const ArrowDownThin = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="5"
      viewBox="0 0 9 5"
      {...props}
      data-palette="ArrowDownThin">
      <path
        fill="var(--brand-bg-primary)"
        d="M7.833.13a.51.51 0 01.68 0 .419.419 0 010 .627l-3.846 3.55a.51.51 0 01-.68 0L.141.757C-.047.584-.047.303.14.13s.492-.173.68 0l3.506 3.235L7.833.13z"
      />
    </svg>)
  );
};

export default ArrowDownThin;
